<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <div style="max-width: 750px; margin: 0px auto; position: relative">
          <div
            style="
              background-position: center 7%;
              background-size: cover;
              overflow: hidden;
              height: 0px;
              padding-bottom: 89%;
              width: 100%;
              border-radius: 4%;
              background-image: url(https://firebasestorage.googleapis.com/v0/b/pec-eps-4819c.appspot.com/o/eps-admin-fe-v1.png?alt=media&token=0e0500ae-a3e3-4627-acbf-85ac203932ae);
            "
          ></div>
          <div
            class="d-none d-md-block"
            style="
              top: 310px;
              left: 133px;
              position: absolute;
              background-position: center 7%;
              background-size: cover;
              padding-bottom: 8%;
              width: 13%;
              border-radius: 4%;
              background-image: url(https://firebasestorage.googleapis.com/v0/b/pec-eps-4819c.appspot.com/o/logo.png?alt=media&token=5a9e5428-a78f-41cd-8960-bdab0ce1482f);
            "
          ></div>
          <div
            class="d-block d-md-none"
            style="
              top: calc(50% - 6%);
              left: calc(50% - 10%);
              position: absolute;
              background-position: center 7%;
              background-size: cover;
              padding-bottom: 12%;
              width: 20%;
              border-radius: 4%;
              background-image: url(https://firebasestorage.googleapis.com/v0/b/pec-eps-4819c.appspot.com/o/logo.png?alt=media&token=5a9e5428-a78f-41cd-8960-bdab0ce1482f);
            "
          ></div>
          <div
            class="d-none d-md-block"
            style="
              top: 325px;
              left: 239px;
              width: 370px;
              position: absolute;
              background-position: center 7%;
              background-size: cover;
              color: #fff;
              font-size: 37px;
              font-weight: 600;
              line-height: 1.3;
            "
          >
            統一企業集團特約商店
          </div>
        </div>
        <div class="mt-2 grey--text">V0.1.1</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HelloWorld",

  data: () => ({
    ecosystem: [
      {
        text: "vuetify-loader",
        href: "https://github.com/vuetifyjs/vuetify-loader",
      },
      {
        text: "github",
        href: "https://github.com/vuetifyjs/vuetify",
      },
      {
        text: "awesome-vuetify",
        href: "https://github.com/vuetifyjs/awesome-vuetify",
      },
    ],
    importantLinks: [
      {
        text: "Documentation",
        href: "https://vuetifyjs.com",
      },
      {
        text: "Chat",
        href: "https://community.vuetifyjs.com",
      },
      {
        text: "Made with Vuetify",
        href: "https://madewithvuejs.com/vuetify",
      },
      {
        text: "Twitter",
        href: "https://twitter.com/vuetifyjs",
      },
      {
        text: "Articles",
        href: "https://medium.com/vuetify",
      },
    ],
    whatsNext: [
      {
        text: "Explore components",
        href: "https://vuetifyjs.com/components/api-explorer",
      },
      {
        text: "Select a layout",
        href: "https://vuetifyjs.com/getting-started/pre-made-layouts",
      },
      {
        text: "Frequently Asked Questions",
        href: "https://vuetifyjs.com/getting-started/frequently-asked-questions",
      },
    ],
  }),
};
</script>
